// extracted by mini-css-extract-plugin
module.exports = {"drawerWidth":"20rem","drawerCollapsedWidth":"8rem","primary":"#ed8611","accent":"#03dac5","info":"#bdbdbd","warning":"#d40000"};